import { defineMessages } from 'react-intl'

export const currenciesCodesList = [
  'AED', 'ARS', 'AUD', 'BRL', 'CAD', 'CHF', 'CLP', 'CNY',
  'COP', 'CRC', 'CZK', 'DKK', 'EGP', 'EUR', 'FJD', 'GBP', 'HKD',
  'HNL', 'HRK', 'HUF', 'IDR', 'ILS', 'INR', 'ISK', 'JPY', 'KHR',
  'KRW', 'LKR', 'MVR', 'MXN', 'MYR', 'NOK', 'NZD', 'PAB', 'PHP',
  'PKR', 'PLN', 'QAR', 'RON', 'RUB', 'SAR', 'SCR', 'SEK', 'SGD',
  'THB', 'TRY', 'TWD', 'UAH', 'USD', 'VND', 'ZAR',
]

export const mainCurrencies = defineMessages({
  USD: { defaultMessage: 'US Dollar' },
  AUD: { defaultMessage: 'Australian Dollar' },
  GBP: { defaultMessage: 'British Pound Sterling' },
  EUR: { defaultMessage: 'Euro' },
})

export const currencies = defineMessages({
  AED: { defaultMessage: 'United Arab Emirates Dirham' },
  ARS: { defaultMessage: 'Argentine Peso' },
  AUD: { defaultMessage: 'Australian Dollar' },
  BRL: { defaultMessage: 'Brazilian Real' },
  CAD: { defaultMessage: 'Canadian Dollar' },
  CHF: { defaultMessage: 'Swiss Franc' },
  CLP: { defaultMessage: 'Chilean Peso' },
  CNY: { defaultMessage: 'Chinese Yuan' },
  COP: { defaultMessage: 'Colombian Peso' },
  CRC: { defaultMessage: 'Costa Rican Colon' },
  CZK: { defaultMessage: 'Czech Republic Koruna' },
  DKK: { defaultMessage: 'Danish Krone' },
  EGP: { defaultMessage: 'Egyptian Pound' },
  EUR: { defaultMessage: 'Euro' },
  FJD: { defaultMessage: 'Fiji Dollar' },
  GBP: { defaultMessage: 'British Pound Sterling' },
  HKD: { defaultMessage: 'Hong Kong Dollar' },
  HNL: { defaultMessage: 'Honduran Lempira' },
  HRK: { defaultMessage: 'Croatian Kuna' },
  HUF: { defaultMessage: 'Hungarian Forint' },
  IDR: { defaultMessage: 'Indonesian Rupiah' },
  ILS: { defaultMessage: 'Israeli New Sheqel' },
  INR: { defaultMessage: 'Indian Rupee' },
  ISK: { defaultMessage: 'Icelandic Krona' },
  JPY: { defaultMessage: 'Japanese Yen' },
  KHR: { defaultMessage: 'Cambodian Riel' },
  KRW: { defaultMessage: 'South Korean Won' },
  LKR: { defaultMessage: 'Sri Lankan Rupee' },
  MVR: { defaultMessage: 'Maldives Rufiyaa' },
  MXN: { defaultMessage: 'Mexican Peso' },
  MYR: { defaultMessage: 'Malaysian Ringgit' },
  NOK: { defaultMessage: 'Norwegian Krone' },
  NZD: { defaultMessage: 'New Zealand Dollar' },
  PAB: { defaultMessage: 'Panamanian Balboa' },
  PHP: { defaultMessage: 'Philippine Peso' },
  PKR: { defaultMessage: 'Pakistani Rupee' },
  PLN: { defaultMessage: 'Polish Zloty' },
  QAR: { defaultMessage: 'Qatari Rial' },
  RON: { defaultMessage: 'Romanian Le' },
  RUB: { defaultMessage: 'Russian Ruble' },
  SAR: { defaultMessage: 'Saudi Riyal' },
  SCR: { defaultMessage: 'Seychelles Rupee' },
  SEK: { defaultMessage: 'Swedish Krona' },
  SGD: { defaultMessage: 'Singapore Dollar' },
  THB: { defaultMessage: 'Thai Baht' },
  TRY: { defaultMessage: 'Turkish Lira' },
  TWD: { defaultMessage: 'New Taiwan Dollar' },
  UAH: { defaultMessage: 'Ukrainian Hryvnia' },
  USD: { defaultMessage: 'US Dollar' },
  VND: { defaultMessage: 'Vietnamese Dong' },
  ZAR: { defaultMessage: 'South African Rand' },
})
